import React, { useState, useEffect } from 'react'
import { Button, Card, Progress, Statistic } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { AssesmentUrl, BaseUrl } from '../../../Constants/Constants'
import { useStateValue } from '../../../../Reducer/reducer'
import ReviewAnswerModule from './ReviewAnswerModule/ReviewAnswerModule'
import McqDescResult from './McqDescResult'
import FeedbackModal from '../../../Feedback/FeedbackModal'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import HomeIcon from '@mui/icons-material/Home'
import './McqResult.css'

const McqResult = () => {

  const navigate = useNavigate()
  const { id, assessmentId } = useParams();
  const localEligibility = localStorage.getItem("course_eligibility");
  const [
    { UserID ,course_eligibility}
  ] = useStateValue();


  const [Score, setScore] = useState('')
  const [Data, setData] = useState('')
  const [timer, setTimer] = useState(10);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [feedbackAvailable, setFeedbackAvailable] = useState(null);

  const getScoreColor = () => {
    if (Score >= (Data.Number_of_questions * 0.8)) {
      return '#4caf50'; // Green for high scores (80% and above)
    } else if (Score >= (Data.Number_of_questions * 0.5)) {
      return '#ffa726'; // Orange for medium scores (50% to 79%)
    } else {
      return '#ff4c4c'; // Red for low scores (below 50%)
    }
  };
  useEffect(() => {
    let body = {
      assessment_id: assessmentId
    }
    axios
      .post(`${BaseUrl}assesment/Assesment_details`, body, { withCredentials: true })
      .then((res) => {
        setData(res.data.data)
        console.log(res.data.data, "len")
      })
      .catch((err) => {

      })
      .finally((res) => {

      })
  }, [])

  useEffect(() => {
    let body = {
      user_id: UserID,
      course_id: id,
      assessment_id: assessmentId
    }
    axios
      .post(`${AssesmentUrl}Get_score`, body)
      .then((res) => {
        console.log(res.data.scores[0], 'res');
        const score = res.data.scores[0]?.score;
        if (score !== undefined) {
          setScore(score);
          console.log(score, 'score');
        }
      })
      .catch((err) => {
        console.log(err)
      })

  }, [])

  // Prefetch feedback forms on results page load
  useEffect(() => {
    if (!id) return;
    axios.post(`${BaseUrl}feedback-form/list_of_feedback_forms`, { course_id: id }, { withCredentials: true })
      .then(res => {
        const list = Array.isArray(res?.data?.data) ? res.data.data : [];
        setFeedbackAvailable(list.length > 0);
      })
      .catch(() => setFeedbackAvailable(false));
  }, [id]);

  // Start countdown only if feedback is available
  useEffect(() => {
    if (!feedbackAvailable) return;
    if (timer === 0) {
      setShowFeedbackModal(true);
      return;
    }
    const interval = setInterval(() => {
      setTimer((prev) => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, [timer, feedbackAvailable]);

  const handleDashboard = () => {
    if (feedbackAvailable) {
      setShowFeedbackModal(true)
    } else {
      navigate(`/`)
    }
  }

  const handleFeedbackSuccess = () => {
    setShowFeedbackModal(false)
    navigate(`/`)
  }
  const scorePercentage = (Data && Data.Number_of_questions && Score !== '') 
    ? Math.round((Score / Data.Number_of_questions) * 100) 
    : 0;

  return (
    <div className="mcqResultContainer">
      <div className="mcqResultContent">
        {/* Main Result Card */}
        <Card className="mcqResultCard">
          {/* Celebration Section */}
          <div className="mcqResultCelebration">
            <div className="mcqResultIconWrapper">
              <EmojiEventsIcon className="mcqResultIcon" />
            </div>
            <h1 className="mcqResultTitle">Congratulations!</h1>
            <p className="mcqResultSubtitle">You've successfully completed the assessment</p>
          </div>

          {/* Feedback Timer */}
          {!showFeedbackModal && feedbackAvailable && (
            <div className="mcqResultFeedbackTimer">
              <AccessTimeIcon className="mcqResultFeedbackTimerIcon" />
              <div className="mcqResultFeedbackTimerContent">
                <span className="mcqResultFeedbackTimerLabel">Feedback form available in</span>
                <span className="mcqResultFeedbackTimerValue">{timer} second{timer !== 1 ? 's' : ''}</span>
              </div>
            </div>
          )}

          {/* Score Display */}
          {Data && Data.assessment_type === 'mcq with description' ? (
            <div className="mcqResultScoreCard descriptionType">
              <CheckCircleIcon className="mcqResultCheckIcon" />
              <p className="mcqResultDescriptionText">Scores will be sent to you via email</p>
            </div>
          ) : (
            <div className="mcqResultScoreSection">
              <div className="mcqResultScoreCard" style={{ borderColor: getScoreColor() }}>
                <div className="mcqResultScoreDisplay">
                  <span className="mcqResultScoreValue" style={{ color: getScoreColor() }}>
                    {Score}
                  </span>
                  <span className="mcqResultScoreDivider">/</span>
                  <span className="mcqResultScoreTotal">{Data ? Data.Number_of_questions : 0}</span>
                </div>
                <div className="mcqResultScoreLabel">Your Test Score</div>
              </div>

              {/* Progress Circle */}
              <div className="mcqResultProgressSection">
                <div className="mcqResultProgressCircle">
                  <Progress
                    type="circle"
                    percent={scorePercentage}
                    strokeColor={{
                      '0%': getScoreColor(),
                      '100%': getScoreColor(),
                    }}
                    strokeWidth={8}
                    format={() => `${scorePercentage}%`}
                    className="mcqResultProgress"
                  />
                </div>
                <div className="mcqResultProgressInfo">
                  <Statistic
                    title="Performance"
                    value={scorePercentage}
                    suffix="%"
                    valueStyle={{ color: getScoreColor(), fontSize: '32px', fontWeight: 700 }}
                  />
                  <p className="mcqResultPerformanceText">
                    {scorePercentage >= 80 
                      ? "Excellent! You've mastered this assessment." 
                      : scorePercentage >= 50 
                      ? "Good job! Keep practicing to improve." 
                      : "Don't worry! Review the material and try again."}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Action Button */}
          <div className="mcqResultActions">
            <Button
              className="mcqResultButton"
              type="primary"
              size="large"
              onClick={handleDashboard}
              icon={<HomeIcon />}
            >
              Continue to Dashboard
            </Button>
          </div>
        </Card>
      </div>

      <FeedbackModal
        visible={showFeedbackModal}
        courseId={id}
        userId={UserID}
        onSuccessRedirect={handleFeedbackSuccess}
      />
    </div>
  )
}

export default McqResult